// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"ec3fc823","703":"898f9fb4","787":"f3d7924f"}[chunkId] + ".chunk.js";
};